import React from "react";
import TypeOfUser from "../../components/marketing/pageSections/documentation/TypeOfUser";
import CategoryAndProduct from "../../components/marketing/pageSections/documentation/CategoryAndProduct";
import StepsToPublishProduct from "../../components/marketing/pageSections/documentation/StepsToPublishProduct";
import SomeAdvices from "../../components/marketing/pageSections/documentation/SomeAdvices";
import PresentationVideos from "../../components/marketing/pageSections/documentation/PresentationVideos";
import H2 from "../../components/elements/titles/H2";
import Paragraph from "../../components/elements/p/Paragraph";
import Container from "../../components/utils/Container";

const BodyDocumentation = () => {
  return (
    <div className="mt-[120px] md:mt-[200px]">
      <Container classe="text-center">
        <H2>Nti / Documentation</H2>
        <Paragraph classe="mt-2 max-w-5xl text-center mx-auto">
          Retrouvez ici les réponses à vos questions pour administrer facilement
          votre boutique. Si vous avez d'autres questions ou si vous avez besoin
          que j'implémente des autres fonctionnalités pour rendre votre boutique
          encore plus puissante, n'hésitez pas à me contacter{" "}
          <span className="text-primary">6 55 95 14 94.</span>
        </Paragraph>
      </Container>
      <div className="mt-8">
        <PresentationVideos />
        <TypeOfUser />
        <CategoryAndProduct />
        <StepsToPublishProduct />
        <SomeAdvices />
      </div>
    </div>
  );
};

export default BodyDocumentation;
